// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1ta8M{max-height:160px;max-height:16rem;overflow-y:auto}._3nLH-{display:-ms-flexbox;display:flex;gap:8px;-ms-flex-pack:justify;font-size:12px;font-size:1.2rem;justify-content:space-between;margin-bottom:8px}._1vliD{color:#6f7ea2;font-weight:500;white-space:nowrap}._1vliD,._3jMUI{font-size:12px;font-size:1.2rem;line-height:18px;line-height:1.8rem}._3jMUI{color:#0a385a;font-weight:700}._3jMUI span{color:#6f7ea2;font-weight:500}._1vliD~._3jMUI{text-align:right}", ""]);
// Exports
exports.locals = {
	"dataList": "_1ta8M",
	"dataList__elem": "_3nLH-",
	"dataList__label": "_1vliD",
	"dataList__value": "_3jMUI"
};
module.exports = exports;
